module.exports = __webpack_public_path__ + "static/media/Ellipse2.3ce9f86f.png";